module.exports = __webpack_public_path__ + "static/media/img_discover-lens.0503a543.png";